import { format } from 'date-fns-tz';

export function convertAmountToPretty(amount, options = { withCurrency: true }) {
  if (typeof amount === 'string' || amount instanceof String)
    amount = amount.replace(",", ".");
  return new Intl.NumberFormat('be-BE', {
    style: options.withCurrency ? 'currency' : undefined,
    currency: options.withCurrency ? 'EUR' : undefined,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function currencyToFloat(currency) {
  if (!currency) return 0;
  return parseFloat(currency.replace(',', '.').replace(/\s+/g, ''));
}

export function moneyMask(value) {
  value = value.replace('.', '').replace(',', '').replace(/\D/g, '');

  if (!value) value = '0';

  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const result = new Intl.NumberFormat('be-BE', options).format(
    parseFloat(value) / 100,
  );

  return result;
}

export function strToFormattedDate(dateStr, formatDate = "dd/MM/yyyy") {
  if (!dateStr) return "";

  const date = new Date(dateStr);

  if (isNaN(date.getTime())) {
    console.error(`Invalid date: ${dateStr}`);
    return "";
  }

  return format(date, formatDate);
}

export function prettyBce(bce) {
  if (bce.length === 10) {
    return `${bce.slice(0, 4)}.${bce.slice(4, 7)}.${bce.slice(7)}`;
  } else {
    return bce;
  }
}

export function prettyIdProcurement(idProcurement) {
  const strIdProcurement = idProcurement.toString();
  return `${strIdProcurement.slice(0, 4)} - ${strIdProcurement.slice(4)}`;
}

export function str2bool(value) {
  if (value && typeof value === "string") {
    if (value.toLowerCase() === "true") return true;
    if (value.toLowerCase() === "false") return false;
  }
  return value;
}
